<ul *autoScrollNavbar="'mixed-loyalty-nav'" class="container mixed-loyalty-nav" >
  <a
    class="nav-item d-flex align-items-center justify-content-center"
    [routerLink]="['/rewards']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label class="mb-0">{{ 'rewards.nav.marketplace' | translate }}</label>
  </a>
  <a
    class="nav-item d-flex align-items-center justify-content-center"
    [routerLink]="['/rewards/events']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label class="mb-0">{{ 'rewards.nav.events' | translate }}</label>
  </a>
  <a
    class="nav-item d-flex align-items-center justify-content-center"
    [routerLink]="['/rewards/raffles']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label class="mb-0">{{ 'rewards.nav.lotto' | translate }}</label>
  </a>
  <a
    class="nav-item d-flex align-items-center justify-content-center"
    [routerLink]="['/rewards/auctions']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label class="mb-0">{{ 'rewards.nav.auctions' | translate }}</label>
  </a>
  <a
    class="nav-item d-flex align-items-center d-none d-lg-flex justify-content-center"
    [routerLink]="['/rewards/wallet']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label class="mb-0">{{ 'rewards.nav.wallet' | translate }}</label>
  </a>
</ul>
